import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_3773375740 from "../../../../../packages/component/src/components/loading/demo/demo1.js?loadDemo";
import legacyImportDemo_2717163647 from "../../../../../packages/component/src/components/loading/demo/demo2.js?loadDemo";
import legacyImportDemo_1377760254 from "../../../../../packages/component/src/components/loading/demo/demo3.js?loadDemo";
import legacyImportDemo_3258780025 from "../../../../../packages/component/src/components/loading/demo/demo4.js?loadDemo";
import legacyImportDemo_3432586232 from "../../../../../packages/component/src/components/loading/demo/demo5.js?loadDemo";
import legacyImportDemo_227063163 from "../../../../../packages/component/src/components/loading/demo/demo6.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_3773375740,
  legacyImportDemo_2717163647,
  legacyImportDemo_1377760254,
  legacyImportDemo_3258780025,
  legacyImportDemo_3432586232,
  legacyImportDemo_227063163,
  React
};